import React, { useState } from 'react';
import { Tabs } from '../ui/Kit';
import CandidateList from './CandidateList';
import CandidateSettings from './CandidateSettings';
import DuplicatesPanel from './DuplicatesPanel';
import ImportPanel from './ImportPanel';
import { isAdmin } from './common';

// The candidate database (bundle 4a-2): All candidates · Import · Duplicates · Settings (company admins).
// Shown at /candidates (admins + Recruit holders) and as Organization → Candidate database (admins).
export default function CandidateDatabase({ basePath = '/candidates' }) {
  const admin = isAdmin();
  const tabs = [{ key: 'all', label: 'All candidates' }, { key: 'import', label: 'Import' }, { key: 'duplicates', label: 'Duplicates' },
    ...(admin ? [{ key: 'settings', label: 'Settings' }] : [])];
  const params = new URLSearchParams(window.location.search);
  const want = params.get('view');
  const importId = params.get('import');
  const [tab, setTab] = useState(importId ? 'import' : (tabs.some((t) => t.key === want) ? want : 'all'));
  const change = (k) => {
    setTab(k);
    const p = new URLSearchParams(window.location.search);
    p.set('view', k);
    p.delete('import');
    window.history.replaceState(null, '', `${basePath}?${p}`);
  };
  return (
    <div>
      <Tabs tabs={tabs} active={tab} onChange={change} label="Candidate database sections" />
      <div className="pt-5" role="tabpanel" id={`panel-${tab}`} aria-labelledby={`tab-${tab}`}>
        {tab === 'all' && <CandidateList />}
        {tab === 'import' && <ImportPanel initialImport={importId ? Number(importId) : null} />}
        {tab === 'duplicates' && <DuplicatesPanel />}
        {tab === 'settings' && admin && <CandidateSettings />}
      </div>
    </div>
  );
}
